import React, { useEffect, useState } from 'react'
import { Select } from '@common/ui'
import { com } from '@eidu/web'
import EntityType = com.eidu.entity.type.EntityType
import EntityTypeId = com.eidu.entity.type.EntityTypeId

type EntityTypeFieldProps = {
  entityTypeId?: EntityTypeId
  types: readonly EntityType[]
  onChange: (value: EntityType) => void
  label: string
  disabled?: boolean
}

function getSelectedType(
  entityTypeId: com.eidu.entity.type.EntityTypeId | undefined,
  types: readonly com.eidu.entity.type.EntityType[]
) {
  if (entityTypeId !== undefined) {
    return entityTypeId.toString()
  } else {
    return types.length > 0 ? types[0].id.toString() : ''
  }
}

const EntityTypeField: React.FC<EntityTypeFieldProps> = ({
  entityTypeId,
  types,
  onChange,
  label,
  disabled = false,
}) => {
  const [selectedOption, setSelectedOption] = useState<string>(getSelectedType(entityTypeId, types))
  const [hasError, setHasError] = useState<boolean>(false)

  useEffect(() => {
    const typeExists =
      entityTypeId === undefined || types.some((type) => type.id.toString() === entityTypeId.toString())
    setHasError(!typeExists)

    setSelectedOption(getSelectedType(entityTypeId, types))
  }, [entityTypeId, types])

  const handleChange = (value: string | null) => {
    if (value === null) return
    setSelectedOption(value)
    onChange(types.find((type) => type.id.toString() === value)!)
  }

  return (
    <Select
      label={label}
      data={types.map((type) => ({ value: type.id.toString(), label: type.name }))}
      value={selectedOption}
      onChange={handleChange}
      disabled={disabled}
      error={
        hasError
          ? 'Warning: The selected entity type was not found in the available types. Please select a valid type.'
          : undefined
      }
      allowDeselect={false}
    />
  )
}

export default EntityTypeField
